/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Fal_DescriptionInputs */

const en_admin_settings_groups_fal_description = /** @type {(inputs: Admin_Settings_Groups_Fal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fal AI API`)
};

/**
* | output |
* | --- |
* | "Fal AI API" |
*
* @param {Admin_Settings_Groups_Fal_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_fal_description = /** @type {((inputs?: Admin_Settings_Groups_Fal_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Fal_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_fal_description(inputs)
});
export { admin_settings_groups_fal_description as "admin.settings.groups.fal.description" }